const coatingData=[
 {name:'PIXAR UV',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarUv.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog','Max UV Protection']},
 {name:'PIXAR BLUV',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarBluv.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog','Max UV Protection','Blue Light protection']},
 {name:'PIXAR AQUA',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarAqua.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog']},
 {name:'PIXAR DRIVE',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarDrive.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog']},
 {name:'PIXAR ANTIFOG',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarAntifog.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Blue Light protection']}
];

function renderCoating(i=0){
 const tabs=document.getElementById('coatingTabs');
 const box=document.getElementById('coatingBox');
 if(!tabs || !box) return;

 tabs.innerHTML=coatingData.map((c,n)=>`
  <button class="gt-coating-tab ${n===i?'active':''}" onclick="renderCoating(${n})">
    <img src="${c.img}" alt="${c.name}">
  </button>
 `).join('');

 const icons=['✳','💧','✺','◎','☕','☂','⌁'];

 box.innerHTML=coatingData[i].features.map((f,n)=>`
  <div class="gt-feature">
    <div class="gt-icon">${icons[n]||'✳'}</div>
    ${f}
  </div>
 `).join('');
}

function rxRows(rx){
 const dia=[80,75,70,65,60,55];
 const minRx=-14;
 const maxRx=16; 
 const range=maxRx-minRx;

 return rx.map((r,i)=>{
  const left=((r[0]-minRx)/range)*100;
  const width=((r[1]-r[0])/range)*100;

  return `
    <div class="gt-rx-row">
      <div class="gt-rx-dia">${dia[i]}</div>
      <div class="gt-rx-track">
        <div class="gt-rx-fill" style="left:${left}%;width:${width}%">
          <span class="gt-rx-left">${Number(r[0]).toFixed(2)}</span>
          <span class="gt-rx-right">+${Number(r[1]).toFixed(2)}</span>
        </div>
      </div>
    </div>`;
 }).join('');
}

document.addEventListener('DOMContentLoaded',function(){
 renderCoating();

 const rx=[
  [-4,7],
  [-7,8],
  [-10,8],
  [-11,14],
  [-12,14],
  [-13,14]
 ];

 const smiRx=document.getElementById('smiRx');
 if(smiRx) smiRx.innerHTML=rxRows(rx);
});